// extracted by mini-css-extract-plugin
export default {"skip_button":"skipButton_skip_button__35F7X"};